'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: flex-start;\n  margin-bottom: 0.2rem;\n  flex-wrap: wrap;\n  button {\n    cursor: pointer;\n    padding: 0.5rem;\n    border-radius: 0.2rem;\n  }\n  @(min-width: 480)\n    .message {\n      display: none;\n    }\n'], ['\n  width: 100%;\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: flex-start;\n  margin-bottom: 0.2rem;\n  flex-wrap: wrap;\n  button {\n    cursor: pointer;\n    padding: 0.5rem;\n    border-radius: 0.2rem;\n  }\n  @(min-width: 480)\n    .message {\n      display: none;\n    }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _addToShowbagButton = require('./add-to-showbag-button');

var _addToShowbagButton2 = _interopRequireDefault(_addToShowbagButton);

var _buyItNowButton = require('./buy-it-now-button');

var _buyItNowButton2 = _interopRequireDefault(_buyItNowButton);

var _addToWishlistButton = require('./add-to-wishlist-button');

var _addToWishlistButton2 = _interopRequireDefault(_addToWishlistButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var InteractionPanel = _styledComponents2.default.div(_templateObject);

/** @class Interactions
  * Component providing a panel of buttons to interact
  * with content items: adding them to the showbag,
  * purchasing online, and adding to a wish list.
  * @prop {string} contentID - the content this interaction corresponds to.
  * @prop {string} productID - the product this interaction corresponds to.
  */

var Interactions = function (_Component) {
  _inherits(Interactions, _Component);

  function Interactions() {
    _classCallCheck(this, Interactions);

    return _possibleConstructorReturn(this, (Interactions.__proto__ || Object.getPrototypeOf(Interactions)).apply(this, arguments));
  }

  _createClass(Interactions, [{
    key: 'render',

    /** @method render
      * Renders the interaction buttons.
      */
    value: function render() {
      // All interactions depend on the full vexpo platform
      // being loaded; so if it is not, don't display them.
      if (!window.vexpo) return null;

      var interactions = [];
      // Check that the showbag vexpo feature is enabled
      // and that this content item is considered swag
      if (window.vexpo.showbag && this.props.swag) {
        interactions.push(_react2.default.createElement(_addToShowbagButton2.default, { key: 'add-to-showbag', content: this.props }));
      }
      // Check that the BuyItNow vexpo feature is enabled
      // and that this content item is associated with a product
      if (window.vexpo.buyItNow && this.props.productID) {
        interactions.push(_react2.default.createElement(_buyItNowButton2.default, { key: 'buy-it-now', productID: this.props.productID }));
      }
      // Check that the wishlist vexpo feature is enabled
      // and that this content item is associated with a product
      if (window.vexpo.giftRegistry && this.props.productID) {
        interactions.push(_react2.default.createElement(_addToWishlistButton2.default, { key: 'add-to-wishlist', productID: this.props.productID }));
      }
      return _react2.default.createElement(
        InteractionPanel,
        null,
        interactions
      );
    }
  }]);

  return Interactions;
}(_react.Component);

exports.default = Interactions;


Interactions.propTypes = {
  contentID: _propTypes2.default.string,
  productID: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/content/interactions.js
// module id = 656
// module chunks = 0